<template>
  <div>
    <SimonModal
      :is-visible="showTermsInfoModal"
      @hide="showTermsInfoModal = false"
      id="terms-info-modal"
    >
      <span class="docM" v-html="termsInfoModalText"></span>
    </SimonModal>
    <AGB
      :agreed.sync="consentAGBProp"
      :process="process"
    >
      <template #headline><slot name="headlineAGB"></slot></template>
      <template #txtAGB><slot name="txtAGB"></slot></template>
      <template #txtAGBwithLink><slot name="txtAGBwithLink"></slot></template>
    </AGB>
    <DataProcessingInfo
      :consents="brandConsents.consents"
    >
      <template #headline><slot name="headlineDataProcessingInfo"></slot></template>
      <template #txtDataProcessingInfo><slot name="txtDataProcessingInfo"></slot></template>
    </DataProcessingInfo>
    <ConsultationConsent v-if="isOrderByAgent !== true"
                         :consents="brandConsents.consents"
                         :selectedInfoExchangeConsentProp.sync="selectedInfoExchangeConsentProp"
                         :selectedContactConsentProp.sync="selectedContactConsentProp"
    >
      <template #headlineConsultationConsent><slot name="headlineConsultationConsent"></slot></template>
      <template #txtConsultationConsent><slot name="txtConsultationConsent"></slot></template>
    </ConsultationConsent>
  </div>
</template>
<script>
import AGB from './AGB.vue'
import DataProcessingInfo from './DataProcessingInfo.vue'
import ConsultationConsent from './ConsultationConsent.vue'
import syncProperty from '@/mixins/syncProperty'
import { mapGetters } from 'vuex'
import SimonModal from '@/components/modal/SimonModal.vue'

export default {
  name: 'ConsentWrapper',
  data: function () {
    return {
      brandConsents: {
        consents: [
        ]
      },
      filterKeys: [
        'data_handling_terms',
        'bew_checkout_terms',
        'contract_terms'
      ],
      showTermsInfoModal: false,
      termsInfoModalText: ''
    }
  },
  mixins: [
    syncProperty('contractTermsVersion', 'contractTermsVersionProp'),
    syncProperty('selectedInfoExchangeConsent', 'selectedInfoExchangeConsentProp'),
    syncProperty('selectedContactConsent', 'selectedContactConsentProp'),
    syncProperty('consentAGB', 'consentAGBProp')
  ],
  components: {
    SimonModal,
    AGB,
    DataProcessingInfo,
    ConsultationConsent
  },
  props: {
    process: {
      type: String,
      default: 'checkout'
    }
  },
  mounted () {
    window.simonSummaryShowModal = (terms, part) => {
      const elem = document.getElementById(terms + '_' + part)
      this.termsInfoModalText = elem.outerHTML
      this.showTermsInfoModal = true
    }

    if (typeof window.$gqlpre.brandConsents !== 'undefined') {
      this.brandConsents = window.$gqlpre.brandConsents
    }
  },
  computed: {
    consents_: function () {
      return Array.isArray(this.brandConsents.consents) ? this.brandConsents.consents : []
    },
    solvencycheckTerms: function () {
      return this.consents_.find(item => item.name === 'solvencycheck_terms')?.text || ''
    },
    termsVersion: function () {
      return this.brandConsents.contractTermsVersion
    },
    ...mapGetters('checkout/info', [
      'orderByAgent'
    ]),
    isOrderByAgent: function () {
      return this.orderByAgent
    },
    isIosDevice () {
      return [
        'iPad Simulator',
        'iPhone Simulator',
        'iPod Simulator',
        'iPad',
        'iPhone',
        'iPod'
      ].includes(navigator.platform) ||
        // iPad on iOS 13 detection
        (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
    }
  }
}
</script>
